import React, { useEffect, useRef, useState } from 'react';

const fmtPrice = (v) => {
    if (v === null || v === undefined) return '—';
    if (v >= 1000) return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
    if (v >= 1) return v.toLocaleString('en-US', { maximumFractionDigits: 4 });
    return v.toLocaleString('en-US', { maximumFractionDigits: 8 });
};

/**
 * Live price with a brief green/red flash on change.
 * Falls back to the fallback price when no tick has arrived yet.
 */
export default function LivePrice({ symbol, tick, fallbackPrice, className = '', prefix = '$' }) {
    const [flash, setFlash] = useState(null); // 'up' | 'down' | null
    const prevRef = useRef(null);
    const timerRef = useRef(null);

    const price = tick?.price ?? fallbackPrice;

    useEffect(() => {
        const current = tick?.price;
        const prev = prevRef.current;
        if (prev !== null && current !== undefined && current !== prev) {
            setFlash(current > prev ? 'up' : 'down');
            if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => setFlash(null), 600);
        }
        if (current !== undefined) prevRef.current = current;
        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [tick?.price, tick?.ts]);

    const flashClass =
        flash === 'up' ? 'bg-emerald-500/25 ring-1 ring-emerald-400/50' :
        flash === 'down' ? 'bg-rose-500/25 ring-1 ring-rose-400/50' : '';

    return (
        <span
            data-testid={`live-price-${symbol}`}
            className={`font-mono tabular-nums px-1 rounded-sm transition-colors duration-500 ${flashClass} ${className}`}
        >
            {prefix}{fmtPrice(price)}
        </span>
    );
}
